import React from 'react';
import group_leader_crown from "../../../assets/images/group_leader_crown.png";

const GDGroupleader = ({ canTransfer, onTransfer, onOkay, glmMode }) => {
  return (
    <div className="relative bg-[#24272C] w-[80%] rounded-2xl flex flex-col items-center py-10 mt-8 mx-auto">
      <div className="absolute -top-6 bg-yellow-300 border-4 border-white rounded-full shadow-md p-2">
        <img
          src={group_leader_crown}
          alt="Group Leader Crown"
          className="h-8 w-8 object-contain"
        />
      </div>
      {glmMode === 'leader_each_select' && (
        <span className="text-gray-800 text-center font-bold text-base mb-3">
          Nominate yourself as a Group Leader.
        </span>
      )}
      <span
        className="text-white text-center font-medium text-base tablet:text-lg laptop:text-xl largescreen:text-2xl w-10/12 mx-auto py-4"
      >
        {glmMode !== 'leader_each_select'
          ? 'You have been selected as a Group Leader for your group.'
          : 'Fastest Finger gets selected!'}
      </span>

      <div className="flex justify-center w-full mt-4">
        <button
          className="px-6 py-3 bg-[#7056A1] text-white rounded-lg"
          onClick={onOkay}
        >
          {glmMode !== 'leader_each_select' ? 'Ok' : 'Nominate Self'}
        </button>
      </div>
    </div>
  );
};

export default GDGroupleader;
